var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    enableBackground: "new 0 0 51 51",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M29.768,33.773c-2.553-2.547-5.105-5.092-7.666-7.638l-0.654-0.65l0.652-0.651 c3.164-3.158,6.332-6.322,9.489-9.482l3.442-3.434c0.385-0.379,0.757-0.741,1.102-1.129c0.633-0.708,0.863-1.633,0.62-2.472 c-0.246-0.862-0.946-1.534-1.877-1.803c-0.981-0.285-1.815-0.024-2.653,0.813L17.738,21.825l-0.014-0.014l-3.676,3.674 c2.342,2.328,4.68,4.656,7.016,6.99l6.196,6.172c0.112,0.114,0.284,0.289,0.469,0.518l0.769,0.768 c1.287,1.288,2.573,2.577,3.867,3.86c0.524,0.522,1.163,0.803,1.852,0.803c0.306,0,0.62-0.053,0.938-0.157 c1.064-0.355,1.684-1.125,1.791-2.229c0.109-1.181-0.678-1.962-0.977-2.257L29.768,33.773z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.1b9724532cf34c5e4591b1942c1ef8f7.svg";
export { ForwardRef as ReactComponent };